<template>
    <div class="clearfix">
        <div v-if="items.length === 0 && !noResults">
            Loading...
        </div>
        <div v-if="noResults">
            <br />
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                There are no recent trades to show
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div v-else>

            <table class="table table-dark table-striped table-sm small">
                <tbody>
                    <tr>
                        <th class="text-center" scope="col">Security</th>
                        <th scope="col">Date</th>
                        <th scope="col">Price</th>
                        <th scope="col">Last</th>
                        <th scope="col">High</th>
                        <th scope="col">Change</th>
                    </tr>
                    <tr v-for="(item, index) in items" :key="index">
                        <td class="text-center"><a class="text-white" :href="'/Trades/Individual?security=' + item.security + '&marketId=' + item.marketId">{{ item.security }}</a></td>
                        <td>{{ formatDateShort(item.trade_Date) }}</td>
                        <td>{{ item.average_Price | currency('$') }}</td>
                        <td>{{ item.lastPrice | currency('$') }}</td>
                        <td :class="negClass(item.fiftyTwoWeekHigh - item.lastPrice)">{{ (item.lastPrice - item.fiftyTwoWeekHigh)/item.lastPrice * 100 | number('0,0.0') }}%</td>
                        <td :class="pnlClass(item)">{{ (item.lastPrice - item.average_Price)/item.average_Price * 100 | number('0,0.0') }}%</td>
                    </tr>
                </tbody>
            </table>


        </div>
    </div>

</template>

<script>
    import axios from 'axios';    

    export default {
        props: {
            portfolioguid: String 
        },
        data: function () {
            return {                
                items: [],    
                portfolioGuid: this.portfolioguid,
                noResults: false
            }
        },
        async mounted() {
            this.getTrades();            
        },
        methods: {            
            getData(obj) {
                console.log(obj);                
            },
            pnlClass: function (item) {
                return (item.lastPrice - item.average_Price)/item.average_Price * 100 < -1.0 ? "text-right text-danger" : "text-right";
            },  
            negClass: function (item) {
                return item > 0 ? "text-right text-danger" : "text-right";
            },
            async getTrades() {

                const { data } = await axios.get('/api/trades/GetRecentTradesByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid                        
                    }
                });

                this.items = data;
                this.noResults = data.length === 0;
            }
        }
    }
</script>